import { render } from "./EnbEstoque.vue?vue&type=template&id=56635145&scoped=true"
import script from "./EnbEstoque.vue?vue&type=script&lang=js"
export * from "./EnbEstoque.vue?vue&type=script&lang=js"

import "./EnbEstoque.vue?vue&type=style&index=0&id=56635145&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56635145"]])

export default __exports__